import "./contact.css";
import Phone from "../../img/phone.png";
import Email from "../../img/email.png";
// import insta from "../../img/insta.webp";
import emailjs from "emailjs-com";
// import tele from "../../img/tt.png";
// import link from "../../img/a.jfif";
// import github from "../../img/github.png";
import Address from "../../img/address.png";
import { useRef, useState } from "react";

const Result = () => {
  return <p style={{color:'white'}}>Thank you contacting with us. Our executive contact you within an hour!</p>;
};
const Contact = () => {
  const form = useRef();
  const [result, showResult] = useState(false);
  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_5v183bk",
        "template_eo8afy6",
        e.target,
        "bVcost1zdWtqQmpiu"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    e.target.reset();
    showResult(true);
  };

  return (<>
    <div className="c">
      <div className="c-bg"></div>
      <div className="c-wrapper">
        <div className="c-left">
          <h1 className="c-title">Reach us through!</h1>
          <div className="c-info">
          <div className="c-info-item">
              <img src={Phone} alt="" className="c-icon" />
              <a
                rel="noreferrer"
                style={{ color: "rgb(235, 246, 245)" }} 
                href="tel: 9650513361"
                target="_blank"
              >
                {" "}
                +91-9650513361
              </a>
            </div>
            <div className="c-info-item">
              <img src={Phone} alt="" className="c-icon" />
              <a
                rel="noreferrer"
                style={{ color: "rgb(235, 246, 245)" }} 
                href="tel: 8826641267"
                target="_blank"
              >
                {" "}
                +91-8826641267
              </a>
            </div>
            <div className="c-info-item">
              <img className="c-icon" src={Email} alt="" />
              <a
                rel="noreferrer"
                style={{ color: "rgb(235, 246, 245)" }} 
                href="https://mail.google.com/mail/u/0/?pli=1#inbox?compose=new"
                target="_blank"
              >
raonipun53@gmail.com
              </a>
            </div>
            {/* <div className="c-info-item">
              <img src={link} alt="" className="c-icon" />
              <a
                rel="noreferrer"
                style={{ color: "grey" }}
                href="https://www.amazon.in/s?me=A1QWS82MLTEUXH&marketplaceID=A21TJRUUN4KGV"
                target="_blank"
              >
                A.D. Enterprises
              </a>
            </div> */}
            {/* <div className="c-info-item">
              <img src={insta} alt="" className="c-icon" />
              <a
                rel="noreferrer"
                style={{ color: "grey" }}
                href="https://www.instagram.com/_ad_enterprises_/"
                target="_blank"
              >
                _ad_enterprises_
              </a>
            </div>  */}
            {/* 
            <div className="c-info-item">
              <img
                src={github}
                alt=""
                className="c-icon"
                style={{ backgroundColor: "white", borderRadius: 20 }}
              />
              <a
                rel="noreferrer"
                style={{ color: "grey" }}
                href="https://github.com/Nyadav123"
                target="_blank"
              >
                Nyadav123
              </a>
            </div>
            <div className="c-info-item">
              <img src={tele} alt="" className="c-icon" />
              <a
                rel="noreferrer"
                style={{ color: "grey" }}
                href="https://mobile.twitter.com/NipunYadav123"
                target="_blank"
              >
                Nipunyadav123
              </a>
            </div>
        */}
            <div className="c-info-item">
              <img className="c-icon" src={Address} alt="" />
              <a
                rel="noreferrer"
                style={{ color: "rgb(235, 246, 245)" }} 
                target="_blank"
                href="https://www.google.co.in/maps/place/Radhe+krishna+tours+and+travel/@28.7417623,77.1370109,15z/data=!4m6!3m5!1s0x390d01785a46e1a5:0x10705f073632c417!8m2!3d28.7457745!4d77.1395953!16s%2Fg%2F11scsm1j0x"
              >
        Radhe Krishna Tour & Travels
              </a>
            </div>
          </div>
        </div>
        <div className="c-right">
          <h1 className="c-title1">
            For booking query please fill the form.
          </h1>
          <form ref={form} onSubmit={sendEmail}>
            <input type="text" placeholder="Name" name="name" />  &nbsp;
            <input type="text" placeholder="Phone No." name="phone" />
            &nbsp; <input type="text" placeholder="Pick up" name="subject" />  &nbsp;
            <input type="text" placeholder="Drop" name="email" />
           
            <textarea
              rows="5"
              placeholder="Booking details drop here!"
              name="message"
              className="message"
            />
            {/* <textarea
              rows="5"
              placeholder="Any Feedback leave here!"
              name="rating"
              className="feedback"
            /> */}
            <button
              style={{ marginTop: 10, marginBottom: 20 }}
              type="submit"
              value="Send"
            >
        <b>SUBMIT</b>
            </button>
            <div style={{ marginTop: 10 }} className="row">
              {result ? <Result /> : null}
              {/* style={{backgroundColor: darkMode && "#333"}}
            if ypu want to add background on darkmode */}
            </div>
          </form>
        </div>
      </div>
    </div>
  <div className="c-type">Copyrights <b>©</b> Radhe Krishna tour & travels. All Rights Reserved | Privacy Policy </div></>
  );
};

export default Contact;
